const ASSET_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Whether a string is shaped like a brand-media / assets-api id.
 *
 * Both services validate every id in a batch and refuse the whole request when one is malformed, so
 * a single stray value - a model that ran on past the id it was emitting, say - would otherwise stop
 * every picture on a board resolving. Callers filter with this before asking, and leave the bad id
 * in their own reference list so it is still reported as unresolved rather than vanishing.
 *
 * Shared rather than kept beside either entity: the asset entity and the brand-media entity both
 * need it and may not import each other.
 */
export const isAssetId = (value: string): boolean => ASSET_ID.test(value);
